const contribute = [{"key":"contribute.greeting","string":"Dzień dobry {variable}, oto Twój przegląd treści."},{"key":"contribute.logout","string":"Wyloguj"}]

export default contribute



// WEBPACK FOOTER //
// ./src/i18n/pl/contribute/_contribute.js